import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

export const BlogCard = ({ post, index }) => (
  <motion.article
    initial={{ opacity: 0, y: 30 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: index * 0.1 }}
    className="group"
  >
    <Link
      to={`/blog/${post.slug}`}
      className="block bg-[#0C0C0C] border border-[#27272A] hover:border-[#007AFF]/50 transition-all duration-300"
      data-testid={`blog-post-${post.slug}`}
    >
      <div className="aspect-video overflow-hidden bg-[#0C0C0C]">
        <img
          src={post.featured_image || 'https://images.pexels.com/photos/3379937/pexels-photo-3379937.jpeg?w=800'}
          alt={post.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
      </div>

      <div className="p-6">
        {post.tags && post.tags.length > 0 && (
          <div className="flex flex-wrap gap-2 mb-4">
            {post.tags.map((tag) => (
              <span key={tag} className="text-[10px] text-[#A1A1AA] uppercase tracking-widest">
                {tag}
                {post.tags.indexOf(tag) < post.tags.length - 1 && <span className="ml-2">·</span>}
              </span>
            ))}
          </div>
        )}

        <h2 className="text-xl font-bold mb-3 leading-tight group-hover:text-[#007AFF] transition-colors">
          {post.title}
        </h2>

        <p className="text-[#A1A1AA] text-sm leading-relaxed line-clamp-3 mb-4">{post.excerpt}</p>

        <div className="flex items-center justify-between pt-4 border-t border-[#27272A]">
          <time dateTime={post.created_at} className="text-[#52525B] text-xs">
            {new Date(post.created_at).toLocaleDateString('en-AU', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}
          </time>
          <span className="text-[#007AFF] text-sm font-medium flex items-center gap-1 group-hover:gap-2 transition-all">
            Read
            <ArrowRight size={14} />
          </span>
        </div>
      </div>
    </Link>
  </motion.article>
);
